module.exports = __webpack_public_path__ + "03fe4eb675e36c423b8bc43d26955828.fbx";